import React from 'react';
type WarningBannerProps = {
  text: string;
};
export function WarningBanner({
  text
}: WarningBannerProps) {
  return <div className="mt-6 bg-red-600 text-white p-3 rounded-sm" data-id="element-251">
      <p className="text-center font-bold" data-id="element-252">⚠️ {text}</p>
    </div>;
}